import React, { useState } from 'react'
import { DialogActions, DialogContent, Modal } from '../Modal/Modal'
import { Box, Button, CircularProgress, Theme } from '@mui/material'

import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      margin: theme.spacing(0.5),
    },
  })
)

interface Props {
  children: any
  header?: any
  body?: any
  isLoading?: boolean
}

export const ConfirmationDialog: React.FC<Props> = ({ children, header, body, isLoading }) => {
  const [show, setShow] = useState(false)
  const [callback, setCallback] = useState<() => Promise<any>>(() => new Promise(() => null))
  const classes = useStyles()

  const onDialogShow = (callback: any) => (event: any) => {
    event.preventDefault()
    event = {
      ...event,
      target: { ...event.target, value: event.target.value },
    }
    setShow(true)
    setCallback(() => callback(event))
  }

  const handleClose = () => setShow(false)
  const handleConfirm = () => {
    callback().then(handleClose)
  }

  return (
    <>
      {children(onDialogShow)}
      <Modal open={show} onClose={handleClose} title={header || 'Potwierdzenie'}>
        <DialogContent>{body || 'Na pewno?'}</DialogContent>

        <DialogActions>
          <Box sx={{ textAlign: 'right' }}>
            <Button
              className={classes.button}
              variant="outlined"
              color="primary"
              onClick={handleClose}
            >
              Anuluj
            </Button>
            <Button
              className={classes.button}
              variant="outlined"
              color="secondary"
              onClick={handleConfirm}
              disabled={isLoading}
              startIcon={isLoading && <CircularProgress size={24} />}
            >
              Potwierdź
            </Button>
          </Box>
        </DialogActions>
      </Modal>
    </>
  )
}
